import MainLayout from '@/layouts/MainLayout.vue';
import type { RouteRecordRaw } from 'vue-router';
import { RouteNames } from './routeNames';
import NotFoundPage from '@/components/404/NotFoundPage.vue';

const catchAllRoute: RouteRecordRaw = {
  path: '/:pathMatch(.*)*',
  component: MainLayout,
  children: [
    {
      name: RouteNames.PAGE_NOT_FOUND,
      path: '',
      component: NotFoundPage,
      meta: {
        pageTitle: 'Main.NotFound',
      },
    },
  ],
};

export default catchAllRoute;
